import type { FC } from 'react';
import { StyleSheet } from 'react-native';
import { Button } from 'react-native-paper';

type PostSubmitButtonProps = {
  label: string;
  onPress: () => void;
  disabled: boolean;
};

const styles = StyleSheet.create({
  button: {
    width: '100%'
  }
});

export const PostSubmitButton: FC<PostSubmitButtonProps> = ({
  label,
  onPress,
  disabled
}) => (
  <Button
    testID="post-creation-submit"
    mode="contained"
    onPress={onPress}
    disabled={disabled}
    style={styles.button}
  >
    {label}
  </Button>
);
